module.exports = __webpack_public_path__ + "static/media/spaceV2.61c4a640.png";